import BasicModel from '../basic/BasicModel'
export default {

  editAdvert (vm, params, listener) {
    let action = 'carShow/carShowInfo/editAdvertisement.action'
    BasicModel.post(vm, action, params, listener)
  }

}
